/*eslint-disable*/
export default function apiFile(value) {
    return api.env.API_ENDPOINT + (value.startsWith('/') ? '/storage' : '/storage/') + value;
}
